/* eslint-disable  */
//@ts-nocheck
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faSyncAlt } from '@fortawesome/free-solid-svg-icons';

import * as mux from './mux';
import auth from '../auth';

import Spinner from '../Spinner';
import StatusBar from '../StatusBar';

import VideoItemList from './VideoItemList';
import VideoUploadModal from './VideoUploadModal';
import { TitledPage } from '@client/new/components/Misc';

class VideoLibrary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      influencerId: null,
      signedUrl: null,
      isModalOpen: false,
      fetching: false,
      videos: [],
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.refreshLibrary = this.refreshLibrary.bind(this);
    this.removeVideoFromLibrary = this.removeVideoFromLibrary.bind(this);
  }

  async componentDidMount() {
    this.setState({
      fetching: true,
    });
    const influencerId = this.props.params.influencerId
      ? this.props.params.influencerId
      : auth.getUser().influencerId;
    const response = await mux.listAllVideoFiles({ influencerId });
    const filtered =
      response && response.data && response.data.length
        ? response.data.filter(
            (e) =>
              e.status === 'PROCESSING_FINISHED' ||
              e.status === 'PROCESSING_STARTED' ||
              e.status === 'UPLOAD_FINISHED' ||
              e.status === 'PROCESSING_ENCODE_FINISHED',
          )
        : [];
    this.setState({
      influencerId,
      videos: filtered,
      fetching: false,
    });
  }

  async removeVideoFromLibrary(id) {
    try {
      this.setState({ fetching: true });
      await mux.deleteVideo({ videoId: id });
      await this.refreshLibrary();
      this.setState({ fetching: false });
    } catch (err) {
      StatusBar.sendErrorMessage('Could not delete a video, try later.');
      this.setState({ fetching: false });
    }
  }

  async refreshLibrary() {
    try {
      this.setState({
        fetching: true,
      });
      const influencerId = this.props.params.influencerId
        ? this.props.params.influencerId
        : auth.getUser().influencerId;
      const response = await mux.listAllVideoFiles({ influencerId });
      const filtered =
        response && response.data && response.data.length
          ? response.data.filter(
              (e) =>
                e.status === 'PROCESSING_FINISHED' ||
                e.status === 'PROCESSING_STARTED' ||
                e.status === 'UPLOAD_FINISHED' ||
                e.status === 'PROCESSING_ENCODE_FINISHED',
            )
          : [];
      this.setState({
        videos: filtered,
        fetching: false,
      });
    } catch (err) {
      console.log(err);
      StatusBar.sendErrorMessage('Could not refresh a video, try later.');
      this.setState({ fetching: false });
    }
  }

  openModal() {
    this.setState({
      isModalOpen: true,
    });
  }

  async closeModal(data) {
    if (data && data.error) {
      StatusBar.sendErrorMessage(
        data.error ? data.error : 'Can not upload a file, try again later.',
      );
    }
    this.setState({
      isModalOpen: false,
    });
  }

  render() {
    const { influencerId, videos, fetching, isModalOpen, signedUrl } =
      this.state;

    const actionsPanel = (
      <div className="box exerciseTemplateListTools">
        <FontAwesomeIcon
          onClick={this.refreshLibrary}
          icon={faSyncAlt}
          style={{
            cursor: 'pointer',
            fontSize: '2rem',
            margin: '0.75rem',
            color: '#6367ef',
          }}
        />
        <FontAwesomeIcon
          onClick={this.openModal}
          icon={faPlusCircle}
          style={{
            cursor: 'pointer',
            fontSize: '2rem',
            margin: '0.75rem',
            color: '#6367ef',
          }}
        />
      </div>
    );

    return (
      <TitledPage title="Video Library" rightContent={actionsPanel}>
        <main id="main">
          {isModalOpen ? (
            <div>
              <VideoUploadModal
                isOpen={isModalOpen}
                onClose={this.closeModal}
                influencerId={influencerId}
                uploadUrl={signedUrl}
                refreshLibrary={this.refreshLibrary}
              />
            </div>
          ) : null}
          {fetching ? (
            <Spinner color={`#6367ef`} style={{ margin: '15rem 32rem' }} />
          ) : (
            <VideoItemList
              videos={videos}
              removeVideoFromLibrary={this.removeVideoFromLibrary}
            />
          )}
        </main>
        <StatusBar.Component />
      </TitledPage>
    );
  }
}

export default VideoLibrary;
